export enum EnumEnv
{
    PROD    = 0,
    STAGE   = 1,
    DEV     = 2,
    LOCAL   = 3 
}